import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

const Mirror = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      combination="9631"
      text={
        <Typography tag="h4">
          Cats learned to change perspective often - sometimes they jump,
          sometimes they lean.
          <br />
          <br />
          This way they can see things from different angles and find things
          nobody else can.
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Mirror;
